<div class="audit-container" *ngIf="data">

  <!-- Header -->
  <div class="summary-card">

    <div class="summary-header">
      <h2>Revenue Leakage Audit Report</h2>

      <span class="risk-badge" [ngClass]="getRiskClass()">
        {{ data.riskLevel }}
      </span>
    </div>

    <div class="summary-grid">

      <div class="metric-card">
        <div class="label">Length of Stay</div>
        <div class="value">
          {{ data.admissionSummary?.lengthOfStayDays }} Days
        </div>
      </div>

      <div class="metric-card">
        <div class="label">Room Category</div>
        <div class="value">
          {{ data.admissionSummary?.roomCategory }}
        </div>
      </div>

      <div class="metric-card">
        <div class="label">Overall Confidence</div>
        <div class="value">
          {{ data.summary?.overallConfidence }}%
        </div>
      </div>

      <div class="metric-card">
        <div class="label">Total Findings</div>
        <div class="value">
          {{ data.summary?.totalFindings }}
        </div>
      </div>

    </div>

    <div class="audit-remark">
      <h4>Audit Remark</h4>
      <p>{{ data.summary?.auditRemark }}</p>
    </div>

  </div>

  <!-- Missing Categories -->
  <div class="section-card" *ngIf="data.missingCategories?.length">

    <h3>⚠️ Missing Billing Categories</h3>

    <div class="finding-card" *ngFor="let item of data.missingCategories">
      <div class="finding-header">
        <span>{{ item.category }}</span>

        <span class="confidence-chip" [ngClass]="getConfidenceClass(item.confidence)">
          {{ item.confidence }}%
        </span>
      </div>

      <p>{{ item.reason }}</p>
    </div>

  </div>

  <!-- Missing Services -->
  <div class="section-card" *ngIf="data.potentialMissingServices?.length">

    <h3>🧾 Potential Missing Services</h3>

    <div class="finding-card" *ngFor="let item of data.potentialMissingServices">
      <div class="finding-header">
        <span>{{ item.service }}</span>

        <span class="confidence-chip" [ngClass]="getConfidenceClass(item.confidence)">
          {{ item.confidence }}%
        </span>
      </div>

      <small class="category">
        {{ item.category }}
      </small>

      <p>{{ item.reason }}</p>
    </div>

  </div>

  <!-- Duplicate Charges -->
  <div class="section-card" *ngIf="data.duplicateCharges?.length">

    <h3>🔁 Possible Duplicate Charges</h3>

    <div class="finding-card" *ngFor="let item of data.duplicateCharges">
      <div class="finding-header">
        <span>{{ item.service }}</span>

        <span class="confidence-chip" [ngClass]="getConfidenceClass(item.confidence)">
          {{ item.confidence }}%
        </span>
      </div>

      <p>{{ item.reason }}</p>
    </div>

  </div>

  <!-- Billing Anomalies -->
  <div class="section-card" *ngIf="data.billingAnomalies?.length">

    <h3>📌 Billing Anomalies</h3>

    <div class="finding-card" *ngFor="let item of data.billingAnomalies">
      <div class="finding-header">
        <span>{{ item.issue }}</span>

        <span class="confidence-chip" [ngClass]="getConfidenceClass(item.confidence)">
          {{ item.confidence }}%
        </span>
      </div>

      <p>{{ item.reason }}</p>
    </div>

  </div>

</div>